export const CandidatesData = [
	{
		'id' : 'C1234',
		'status': 'READY',
		'fullname' : 'John Doe',
		'email' : 'johndoe@gmail.com',
		'dateAdded' : '20/12/2017',
		'initials' : 'JD',
		'notice' : '21 Days Notice Period',
		'jobType' : 'Permanent',
		'candidatePhoto' : 'yes',
		'currentPosition' : 'Customer Integration Management Specialist',
		'currentPositionCompany' : 'Intel',
		'skillsHighlight' : [
			{
				'text' : 'MS Excel',
				'tab' : 'skills'
			},
			{
				'text' : 'MS Word',
				'tab' : 'skills'
			},
			{
				'text' : 'Customer Service',
				'tab' : 'experience'
			},
			{
				'text' : 'Team Work',
				'tab' : 'experience'
			},
			{
				'text' : 'Fluent English',
				'tab' : 'languages'
			},
			{
				'text' : 'IT skills',
				'tab' : 'skills'
			}
		],
		'experienceHighlight' : [
			'Marketing Manager | O2',
			'Marketing Team Lead | Three Network',
		],
		'location' : 'Raheen, Limerick',
		'recruiterComments' : [
			'Very motivated to provide great customer service.',
			'Previous 2 years experience with telephone customer service.',
			'Lots of responsibilities including team management.',
			'Has training and certificates in ECDL.',
			'They have fluent English and excellent communication skills.'
		],
		'experience' : [
			{
				'dateStart' : 'November 2015',
				'dateEnd' : 'To present',
				'title' : 'Customer Service Manager',
				'company' : 'Intel',
				'description' : 'Accurately updating administrative records. Promoting products and services.Resolving face to face, telephone and email queries quickly and to completion.'
			},
			{
				'dateStart' : 'December 2014',
				'dateEnd' : 'November 2015',
				'title' : 'Customer Service Advisor',
				'company' : 'o2',
				'description' : 'Taking ownership for queries from first contact to resolution.Interacting directly with potential, new and existing clients.Development, maintenance and retention of customer relationships. Informing customers of all the latest products.'
			},
			{
				'dateStart' : 'February 2013',
				'dateEnd' : 'June 2014',
				'title' : 'Hotel Manager',
				'company' : 'Lake Hotel',
				'description' : 'Resolving face to face, telephone and email queries quickly and to completion. Implementing agreed promotional activities. Monitoring until completion outstanding orders and enquiries.Processing customer registrations'
			}
		],
		'skills' : [
			{
				'skill' : 'MS Excel',
				'level' : 1
			},
			{
				'skill' : 'MS Word',
				'level' : 2
			},
			{
				'skill' : 'IT Skills',
				'level' : 5
			},
			{
				'skill' : 'Typing Skills',
				'level' : 5
			},
		],
		'education' : [
			{
				'accreditation' : 'MA in Business & Marketing Management',
				'institution' : 'University College',
				'location' : 'Dublin, Ireland',
				'dateStart' : '2012',
				'dateEnd' : '2013',
				'description' : 'First Class Honours. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium'
			},
			{
				'accreditation' : 'BA in Business & Marketing Management',
				'institution' : 'UCC',
				'location' : 'Ireland',
				'dateStart' : '2011',
				'dateEnd' : '2012',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'training' : [
			{
				'accreditation' : 'Certication in Excel',
				'institution' : 'Microsoft Inc.',
				'dateStart' : '2012',
				'dateEnd' : '2013',
			},
			{
				'accreditation' : 'Certification in Marketo',
				'institution' : 'Marketo Inc.',
				'dateStart' : '2011',
				'dateEnd' : '2012',
			}
		],
		'languages' : [
			{
				'language' : 'English',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'German',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'Irish',
				'fluency' : 'Intermediate',
				'skill' : 3
			},
			{
				'language' : 'French',
				'fluency' : 'Beginner',
				'skill' : 1
			}
		],
		'hobbies' : [
			{
				'hobby' : 'Running',
			},
			{
				'hobby' : 'Travelling',
			},
			{
				'hobby' : 'Yoga',
			},
			{
				'hobby' : 'Football Coaching',
			},
			{
				'hobby' : 'Cycling',
			},
			{
				'hobby' : 'Mountain Climbing',
			},
			{
				'hobby' : 'Pilates',
			},
			{
				'hobby' : 'Photography',
			},
			{
				'hobby' : 'Rowing',
			}
		]
	},
	{
		'id' : 'C1235',
		'status': 'SUITABLE',
		'fullname' : 'Amanda Lyons',
		'email' : 'amandalyons@gmail.com',
		'dateAdded' : '20/12/2017',
		'initials' : 'AL',
		'notice' : '30 Days Notice Period',
		'jobType' : 'Permanent',
		'currentPosition' : 'Senior Marketing Manager',
		'currentPositionCompany' : 'Intel',
		'skillsHighlight' : [
			{
				'text' : 'MS Excel',
				'tab' : 'skills'
			},
			{
				'text' : 'Marketo',
				'tab' : 'skills'
			},
			{
				'text' : 'Photoshop',
				'tab' : 'skills'
			},
			{
				'text' : 'Team Work',
				'tab' : 'experience'
			}
		],
		'experienceHighlight' : '5 Years Professional Experience | 6 Positions',
		'location' : 'Raheen, Limerick',
		'recruiterComments' : [
			'Very motivated to provide great customer service.',
			'Previous 2 years experience with telephone customer service.',
			'Lots of responsibilities including team management.',
			'Has training and certificates in ECDL.',
			'They have fluent English and excellent communication skills.'
		],
		'highLightText' : 'I am a passionate Marketing Manager for 10 years. I love to work with various teams and my clients include start-ups to multinationals. I enjoy problem solving and have ambition to manage marketing teams with small and large budgets.',
		'experience' : [
			{
				'dateStart' : '2015',
				'dateEnd' : '2018',
				'title' : 'Senior Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2014',
				'dateEnd' : '2015',
				'title' : 'Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2013',
				'dateEnd' : '2014',
				'title' : 'Marketing Team Lead',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'skills' : [
			{
				'skill' : 'MS Excel',
				'level' : 1
			},
			{
				'skill' : 'MS Word',
				'level' : 2
			},
		],
		'education' : [
			{
				'accreditation' : 'MA in Business & Marketing Management',
				'institution' : 'University College',
				'location' : 'Dublin, Ireland',
				'dateStart' : '2012',
				'dateEnd' : '2013',
				'description' : 'First Class Honours. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium'
			},
			{
				'accreditation' : 'BA in Business & Marketing Management',
				'institution' : 'UCC',
				'location' : 'Ireland',
				'dateStart' : '2011',
				'dateEnd' : '2012',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'training' : [
			{
				'accreditation' : 'Certication in Excel',
				'institution' : 'Microsoft Inc.',
				'dateStart' : '2012',
				'dateEnd' : '2013',
			},
			{
				'accreditation' : 'Certification in Marketo',
				'institution' : 'Marketo Inc.',
				'dateStart' : '2011',
				'dateEnd' : '2012',
			}
		],
		'languages' : [
			{
				'language' : 'English',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'German',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'Irish',
				'fluency' : 'Intermediate',
				'skill' : 3
			},
			{
				'language' : 'French',
				'fluency' : 'Beginner',
				'skill' : 1
			}
		],
		'hobbies' : [
			{
				'hobby' : 'Running',
			},
			{
				'hobby' : 'Travelling',
			},
			{
				'hobby' : 'Yoga',
			},
			{
				'hobby' : 'Football Coaching',
			},
			{
				'hobby' : 'Cycling',
			},
			{
				'hobby' : 'Mountain Climbing',
			},
			{
				'hobby' : 'Pilates',
			},
			{
				'hobby' : 'Photography',
			},
			{
				'hobby' : 'Rowing',
			}
		]
	},
	{
		'id' : 'C1236',
		'status': 'UNSUITABLE',
		'fullname' : 'Peter Fitzpatrick',
		'initials' : 'PF',
		'email' : 'peterfitzpatrick@gmail.com',
		'dateAdded' : '20/12/2017',
		'notice' : '21 Days Notice Period',
		'jobType' : 'Permanent',
		'currentPosition' : 'Senior Marketing Manager',
		'currentPositionCompany' : 'Intel',
		'skillsHighlight' : [
			{
				'text' : 'MS Excel',
				'tab' : 'skills'
			},
			{
				'text' : 'Marketo',
				'tab' : 'skills'
			},
			{
				'text' : 'Photoshop',
				'tab' : 'skills'
			},
			{
				'text' : 'Team Work',
				'tab' : 'experience'
			}
		],
		'experienceHighlight' : '5 Years Professional Experience | 6 Positions',
		'location' : 'Raheen, Limerick',
		'recruiterComments' : [
			'Very motivated to provide great customer service.',
			'Previous 2 years experience with telephone customer service.',
			'Lots of responsibilities including team management.',
			'Has training and certificates in ECDL.',
			'They have fluent English and excellent communication skills.'
		],
		'highLightText' : 'I am a passionate Marketing Manager for 10 years. I love to work with various teams and my clients include start-ups to multinationals. I enjoy problem solving and have ambition to manage marketing teams with small and large budgets.',
		'experience' : [
			{
				'dateStart' : '2015',
				'dateEnd' : '2018',
				'title' : 'Senior Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2014',
				'dateEnd' : '2015',
				'title' : 'Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2013',
				'dateEnd' : '2014',
				'title' : 'Marketing Team Lead',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'skills' : [
			{
				'skill' : 'MS Excel',
				'level' : 1
			},
			{
				'skill' : 'MS Word',
				'level' : 2
			},
		],
		'education' : [
			{
				'accreditation' : 'MA in Business & Marketing Management',
				'institution' : 'University College',
				'location' : 'Dublin, Ireland',
				'dateStart' : '2012',
				'dateEnd' : '2013',
				'description' : 'First Class Honours. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium'
			},
			{
				'accreditation' : 'BA in Business & Marketing Management',
				'institution' : 'UCC',
				'location' : 'Ireland',
				'dateStart' : '2011',
				'dateEnd' : '2012',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'training' : [
			{
				'accreditation' : 'Certication in Excel',
				'institution' : 'Microsoft Inc.',
				'dateStart' : '2012',
				'dateEnd' : '2013',
			},
			{
				'accreditation' : 'Certification in Marketo',
				'institution' : 'Marketo Inc.',
				'dateStart' : '2011',
				'dateEnd' : '2012',
			}
		],
		'languages' : [
			{
				'language' : 'English',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'German',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'Irish',
				'fluency' : 'Intermediate',
				'skill' : 3
			},
			{
				'language' : 'French',
				'fluency' : 'Beginner',
				'skill' : 1
			}
		],
		'hobbies' : [
			{
				'hobby' : 'Running',
			},
			{
				'hobby' : 'Travelling',
			},
			{
				'hobby' : 'Yoga',
			},
			{
				'hobby' : 'Football Coaching',
			},
			{
				'hobby' : 'Cycling',
			},
			{
				'hobby' : 'Mountain Climbing',
			},
			{
				'hobby' : 'Pilates',
			},
			{
				'hobby' : 'Photography',
			},
			{
				'hobby' : 'Rowing',
			}
		]
	},
	{
		'id' : 'C1237',
		'status': 'READY',
		'fullname' : 'Emily Curtis',
		'initials' : 'EC',
		'email' : 'johndoe@gmail.com',
		'dateAdded' : '20/12/2017',
		'notice' : '2 Weeks Notice Period',
		'jobType' : 'Permanent',
		'currentPosition' : 'Senior Marketing Manager',
		'currentPositionCompany' : 'Intel',
		'skillsHighlight' : [
			{
				'text' : 'MS Excel',
				'tab' : 'skills'
			},
			{
				'text' : 'Marketo',
				'tab' : 'skills'
			},
			{
				'text' : 'Photoshop',
				'tab' : 'skills'
			},
			{
				'text' : 'Team Work',
				'tab' : 'experience'
			}
		],
		'experienceHighlight' : '5 Years Professional Experience | 6 Positions',
		'location' : 'Raheen, Limerick',
		'recruiterComments' : [
			'Very motivated to provide great customer service.',
			'Previous 2 years experience with telephone customer service.',
			'Lots of responsibilities including team management.',
			'Has training and certificates in ECDL.',
			'They have fluent English and excellent communication skills.'
		],
		'highLightText' : 'I am a passionate Marketing Manager for 10 years. I love to work with various teams and my clients include start-ups to multinationals. I enjoy problem solving and have ambition to manage marketing teams with small and large budgets.',
		'experience' : [
			{
				'dateStart' : '2015',
				'dateEnd' : '2018',
				'title' : 'Senior Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2014',
				'dateEnd' : '2015',
				'title' : 'Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2013',
				'dateEnd' : '2014',
				'title' : 'Marketing Team Lead',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'skills' : [
			{
				'skill' : 'MS Excel',
				'level' : 1
			},
			{
				'skill' : 'MS Word',
				'level' : 2
			},
		],
		'education' : [
			{
				'accreditation' : 'MA in Business & Marketing Management',
				'institution' : 'University College',
				'location' : 'Dublin, Ireland',
				'dateStart' : '2012',
				'dateEnd' : '2013',
				'description' : 'First Class Honours. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium'
			},
			{
				'accreditation' : 'BA in Business & Marketing Management',
				'institution' : 'UCC',
				'location' : 'Ireland',
				'dateStart' : '2011',
				'dateEnd' : '2012',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'training' : [
			{
				'accreditation' : 'Certication in Excel',
				'institution' : 'Microsoft Inc.',
				'dateStart' : '2012',
				'dateEnd' : '2013',
			},
			{
				'accreditation' : 'Certification in Marketo',
				'institution' : 'Marketo Inc.',
				'dateStart' : '2011',
				'dateEnd' : '2012',
			}
		],
		'languages' : [
			{
				'language' : 'English',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'German',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'Irish',
				'fluency' : 'Intermediate',
				'skill' : 3
			},
			{
				'language' : 'French',
				'fluency' : 'Beginner',
				'skill' : 1
			}
		],
		'hobbies' : [
			{
				'hobby' : 'Running',
			},
			{
				'hobby' : 'Travelling',
			},
			{
				'hobby' : 'Yoga',
			},
			{
				'hobby' : 'Football Coaching',
			},
			{
				'hobby' : 'Cycling',
			},
			{
				'hobby' : 'Mountain Climbing',
			},
			{
				'hobby' : 'Pilates',
			},
			{
				'hobby' : 'Photography',
			},
			{
				'hobby' : 'Rowing',
			}
		]
	},
	{
		'id' : 'C1238',
		'status': 'READY',
		'fullname' : 'Dylan Moran',
		'initials' : 'DM',
		'email' : 'johndoe@gmail.com',
		'dateAdded' : '20/12/2017',
		'notice' : '2 Weeks Notice Period',
		'jobType' : 'Permanent',
		'currentPosition' : 'Senior Marketing Manager',
		'currentPositionCompany' : 'Intel',
		'skillsHighlight' : [
			{
				'text' : 'MS Excel',
				'tab' : 'skills'
			},
			{
				'text' : 'Marketo',
				'tab' : 'skills'
			},
			{
				'text' : 'Photoshop',
				'tab' : 'skills'
			},
			{
				'text' : 'Team Work',
				'tab' : 'experience'
			}
		],
		'experienceHighlight' : '5 Years Professional Experience | 6 Positions',
		'location' : 'Raheen, Limerick',
		'recruiterComments' : [
			'Very motivated to provide great customer service.',
			'Previous 2 years experience with telephone customer service.',
			'Lots of responsibilities including team management.',
			'Has training and certificates in ECDL.',
			'They have fluent English and excellent communication skills.'
		],
		'highLightText' : 'I am a passionate Marketing Manager for 10 years. I love to work with various teams and my clients include start-ups to multinationals. I enjoy problem solving and have ambition to manage marketing teams with small and large budgets.',
		'experience' : [
			{
				'dateStart' : '2015',
				'dateEnd' : '2018',
				'title' : 'Senior Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2014',
				'dateEnd' : '2015',
				'title' : 'Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2013',
				'dateEnd' : '2014',
				'title' : 'Marketing Team Lead',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'skills' : [
			{
				'skill' : 'MS Excel',
				'level' : 1
			},
			{
				'skill' : 'MS Word',
				'level' : 2
			},
				{
				'skill' : 'IT SkillsL',
				'level' : 5
			},
		],
		'education' : [
			{
				'accreditation' : 'MA in Business & Marketing Management',
				'institution' : 'University College',
				'location' : 'Dublin, Ireland',
				'dateStart' : '2012',
				'dateEnd' : '2013',
				'description' : 'First Class Honours. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium'
			},
			{
				'accreditation' : 'BA in Business & Marketing Management',
				'institution' : 'UCC',
				'location' : 'Ireland',
				'dateStart' : '2011',
				'dateEnd' : '2012',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'training' : [
			{
				'accreditation' : 'Certication in Excel',
				'institution' : 'Microsoft Inc.',
				'dateStart' : '2012',
				'dateEnd' : '2013',
			},
			{
				'accreditation' : 'Certification in Marketo',
				'institution' : 'Marketo Inc.',
				'dateStart' : '2011',
				'dateEnd' : '2012',
			}
		],
		'languages' : [
			{
				'language' : 'English',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'German',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'Irish',
				'fluency' : 'Intermediate',
				'skill' : 3
			},
			{
				'language' : 'French',
				'fluency' : 'Beginner',
				'skill' : 1
			}
		],
		'hobbies' : [
			{
				'hobby' : 'Running',
			},
			{
				'hobby' : 'Travelling',
			},
			{
				'hobby' : 'Yoga',
			},
			{
				'hobby' : 'Football Coaching',
			},
			{
				'hobby' : 'Cycling',
			},
			{
				'hobby' : 'Mountain Climbing',
			},
			{
				'hobby' : 'Pilates',
			},
			{
				'hobby' : 'Photography',
			},
			{
				'hobby' : 'Rowing',
			}
		]
	},
	{
		'id' : 'C1239',
		'status': 'READY',
		'fullname' : 'Ciara Gooding',
		'initials' : 'CG',
		'email' : 'ciaragooding@gmail.com',
		'dateAdded' : '20/12/2017',
		'notice' : '2 Weeks Notice Period',
		'jobType' : 'Permanent',
		'currentPosition' : 'Senior Marketing Manager',
		'currentPositionCompany' : 'Intel',
		'skillsHighlight' : [
			{
				'text' : 'MS Excel',
				'tab' : 'skills'
			},
			{
				'text' : 'Marketo',
				'tab' : 'skills'
			},
			{
				'text' : 'Photoshop',
				'tab' : 'skills'
			},
			{
				'text' : 'Team Work',
				'tab' : 'experience'
			}
		],
		'experienceHighlight' : '5 Years Professional Experience | 6 Positions',
		'location' : 'Raheen, Limerick',
		'recruiterComments' : [
			'Very motivated to provide great customer service.',
			'Previous 2 years experience with telephone customer service.',
			'Lots of responsibilities including team management.',
			'Has training and certificates in ECDL.',
			'They have fluent English and excellent communication skills.'
		],
		'highLightText' : 'I am a passionate Marketing Manager for 10 years. I love to work with various teams and my clients include start-ups to multinationals. I enjoy problem solving and have ambition to manage marketing teams with small and large budgets.',
		'experience' : [
			{
				'dateStart' : '2015',
				'dateEnd' : '2018',
				'title' : 'Senior Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2014',
				'dateEnd' : '2015',
				'title' : 'Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2013',
				'dateEnd' : '2014',
				'title' : 'Marketing Team Lead',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'skills' : [
			{
				'skill' : 'MS Excel',
				'level' : 1
			},
			{
				'skill' : 'MS Word',
				'level' : 2
			},
		],
		'education' : [
			{
				'accreditation' : 'MA in Business & Marketing Management',
				'institution' : 'University College',
				'location' : 'Dublin, Ireland',
				'dateStart' : '2012',
				'dateEnd' : '2013',
				'description' : 'First Class Honours. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium'
			},
			{
				'accreditation' : 'BA in Business & Marketing Management',
				'institution' : 'UCC',
				'location' : 'Ireland',
				'dateStart' : '2011',
				'dateEnd' : '2012',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'training' : [
			{
				'accreditation' : 'Certication in Excel',
				'institution' : 'Microsoft Inc.',
				'dateStart' : '2012',
				'dateEnd' : '2013',
			},
			{
				'accreditation' : 'Certification in Marketo',
				'institution' : 'Marketo Inc.',
				'dateStart' : '2011',
				'dateEnd' : '2012',
			}
		],
		'languages' : [
			{
				'language' : 'English',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'German',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'Irish',
				'fluency' : 'Intermediate',
				'skill' : 3
			},
			{
				'language' : 'French',
				'fluency' : 'Beginner',
				'skill' : 1
			}
		],
		'hobbies' : [
			{
				'hobby' : 'Running',
			},
			{
				'hobby' : 'Travelling',
			},
			{
				'hobby' : 'Yoga',
			},
			{
				'hobby' : 'Football Coaching',
			},
			{
				'hobby' : 'Cycling',
			},
			{
				'hobby' : 'Mountain Climbing',
			},
			{
				'hobby' : 'Pilates',
			},
			{
				'hobby' : 'Photography',
			},
			{
				'hobby' : 'Rowing',
			}
		]
	},
	{
		'id' : 'C12310',
		'status': 'READY',
		'fullname' : 'Jack Keery',
		'initials' : 'Jk',
		'notice' : '2 Weeks Notice Period',
		'email' : 'jackkeery@gmail.com',
		'dateAdded' : '20/12/2017',
		'jobType' : 'Permanent',
		'currentPosition' : 'Customer Service Advisor',
		'currentPositionCompany' : 'Viagogo',
		'skillsHighlight' : [
			{
				'text' : 'MS Excel',
				'tab' : 'skills'
			},
			{
				'text' : 'Marketo',
				'tab' : 'skills'
			},
			{
				'text' : 'Photoshop',
				'tab' : 'skills'
			},
			{
				'text' : 'Team Work',
				'tab' : 'experience'
			}
		],
		'experienceHighlight' : '5 Years Professional Experience | 6 Positions',
		'location' : 'Raheen, Limerick',
		'recruiterComments' : [
			'Very motivated to provide great customer service.',
			'Previous 2 years experience with telephone customer service.',
			'Lots of responsibilities including team management.',
			'Has training and certificates in ECDL.',
			'They have fluent English and excellent communication skills.'
		],
		'highLightText' : 'I am a passionate Marketing Manager for 10 years. I love to work with various teams and my clients include start-ups to multinationals. I enjoy problem solving and have ambition to manage marketing teams with small and large budgets.',
		'experience' : [
			{
				'dateStart' : '2015',
				'dateEnd' : '2018',
				'title' : 'Senior Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2014',
				'dateEnd' : '2015',
				'title' : 'Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2013',
				'dateEnd' : '2014',
				'title' : 'Marketing Team Lead',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'skills' : [
			{
				'skill' : 'MS Excel',
				'level' : 1
			},
			{
				'skill' : 'MS Word',
				'level' : 2
			},
			{
				'skill' : 'Marketo',
				'level' : 2
			},
			{
				'skill' : 'Photoshop',
				'level' : 4
			},
		],
		'education' : [
			{
				'accreditation' : 'MSC in Interactive Media',
				'institution' : 'University of Limerick',
				'location' : 'Limerick, Ireland',
				'dateStart' : '2008',
				'dateEnd' : '2012',
				'description' : 'First Class Honours. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium'
			},
			{
				'accreditation' : 'BSC in Digital Media Design',
				'institution' : 'University of Limerick',
				'location' : 'Ireland',
				'dateStart' : '2012',
				'dateEnd' : '2013',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'training' : [
			{
				'accreditation' : 'Certication in Excel',
				'institution' : 'Microsoft Inc.',
				'dateStart' : '2012',
				'dateEnd' : '2013',
			},
			{
				'accreditation' : 'Certification in Marketo',
				'institution' : 'Marketo Inc.',
				'dateStart' : '2011',
				'dateEnd' : '2012',
			}
		],
		'languages' : [
			{
				'language' : 'English',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'German',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'Irish',
				'fluency' : 'Intermediate',
				'skill' : 3
			},
			{
				'language' : 'French',
				'fluency' : 'Beginner',
				'skill' : 1
			}
		],
		'hobbies' : [
			{
				'hobby' : 'Running',
			},
			{
				'hobby' : 'Travelling',
			},
			{
				'hobby' : 'Yoga',
			},
			{
				'hobby' : 'Football Coaching',
			},
			{
				'hobby' : 'Cycling',
			},
			{
				'hobby' : 'Mountain Climbing',
			},
			{
				'hobby' : 'Pilates',
			},
			{
				'hobby' : 'Photography',
			},
			{
				'hobby' : 'Rowing',
			}
		]
	},
	{
		'id' : 'C12311',
		'status': 'READY',
		'fullname' : 'Damien Downs',
		'initials' : 'DD',
		'email' : 'damiendowns_2013_123@gmail.com',
		'dateAdded' : '20/12/2017',
		'notice' : '2 Weeks Notice Period',
		'jobType' : 'Permanent',
		'currentPosition' : 'Senior Marketing Manager',
		'currentPositionCompany' : 'Intel',
		'skillsHighlight' : [
			{
				'text' : 'MS Excel',
				'tab' : 'skills'
			},
			{
				'text' : 'Marketo',
				'tab' : 'skills'
			},
			{
				'text' : 'Photoshop',
				'tab' : 'skills'
			},
			{
				'text' : 'Team Work',
				'tab' : 'experience'
			}
		],
		'experienceHighlight' : '5 Years Professional Experience | 6 Positions',
		'location' : 'Raheen, Limerick',
		'recruiterComments' : [
			'Very motivated to provide great customer service.',
			'Previous 2 years experience with telephone customer service.',
			'Lots of responsibilities including team management.',
			'Has training and certificates in ECDL.',
			'They have fluent English and excellent communication skills.'
		],
		'highLightText' : 'I am a passionate Marketing Manager for 10 years. I love to work with various teams and my clients include start-ups to multinationals. I enjoy problem solving and have ambition to manage marketing teams with small and large budgets.',
		'experience' : [
			{
				'dateStart' : '2015',
				'dateEnd' : '2018',
				'title' : 'Senior Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2014',
				'dateEnd' : '2015',
				'title' : 'Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2013',
				'dateEnd' : '2014',
				'title' : 'Marketing Team Lead',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'skills' : [
			{
				'skill' : 'MS Excel',
				'level' : 1
			},
			{
				'skill' : 'MS Word',
				'level' : 2
			},
		],
		'education' : [
			{
				'accreditation' : 'MA in Business & Marketing Management',
				'institution' : 'University College',
				'location' : 'Dublin, Ireland',
				'dateStart' : '2012',
				'dateEnd' : '2013',
				'description' : 'First Class Honours. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium'
			},
			{
				'accreditation' : 'BA in Business & Marketing Management',
				'institution' : 'UCC',
				'location' : 'Ireland',
				'dateStart' : '2011',
				'dateEnd' : '2012',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'training' : [
			{
				'accreditation' : 'Certication in Excel',
				'institution' : 'Microsoft Inc.',
				'dateStart' : '2012',
				'dateEnd' : '2013',
			},
			{
				'accreditation' : 'Certification in Marketo',
				'institution' : 'Marketo Inc.',
				'dateStart' : '2011',
				'dateEnd' : '2012',
			}
		],
		'languages' : [
			{
				'language' : 'English',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'German',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'Irish',
				'fluency' : 'Intermediate',
				'skill' : 3
			},
			{
				'language' : 'French',
				'fluency' : 'Beginner',
				'skill' : 1
			}
		],
		'hobbies' : [
			{
				'hobby' : 'Running',
			},
			{
				'hobby' : 'Travelling',
			},
			{
				'hobby' : 'Yoga',
			},
			{
				'hobby' : 'Football Coaching',
			},
			{
				'hobby' : 'Cycling',
			},
			{
				'hobby' : 'Mountain Climbing',
			},
			{
				'hobby' : 'Pilates',
			},
			{
				'hobby' : 'Photography',
			},
			{
				'hobby' : 'Rowing',
			}
		]
	},
	{
		'id' : 'C12312',
		'status': 'READY',
		'fullname' : 'Chelsea Tyler',
		'initials' : 'CT',
		'email' : 'chelseatyler@gmail.com',
		'dateAdded' : '20/12/2017',
		'notice' : '2 Weeks Notice Period',
		'jobType' : 'Permanent',
		'currentPosition' : 'Senior Marketing Manager',
		'currentPositionCompany' : 'Intel',
		'skillsHighlight' : [
			{
				'text' : 'MS Excel',
				'tab' : 'skills'
			},
			{
				'text' : 'Marketo',
				'tab' : 'skills'
			},
			{
				'text' : 'Photoshop',
				'tab' : 'skills'
			},
			{
				'text' : 'Team Work',
				'tab' : 'experience'
			}
		],
		'experienceHighlight' : '5 Years Professional Experience | 6 Positions',
		'location' : 'Raheen, Limerick',
		'recruiterComments' : [
			'Very motivated to provide great customer service.',
			'Previous 2 years experience with telephone customer service.',
			'Lots of responsibilities including team management.',
			'Has training and certificates in ECDL.',
			'They have fluent English and excellent communication skills.'
		],
		'highLightText' : 'I am a passionate Marketing Manager for 10 years. I love to work with various teams and my clients include start-ups to multinationals. I enjoy problem solving and have ambition to manage marketing teams with small and large budgets.',
		'experience' : [
			{
				'dateStart' : '2015',
				'dateEnd' : '2018',
				'title' : 'Senior Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2014',
				'dateEnd' : '2015',
				'title' : 'Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2013',
				'dateEnd' : '2014',
				'title' : 'Marketing Team Lead',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'skills' : [
			{
				'skill' : 'MS Excel',
				'level' : 1
			},
			{
				'skill' : 'MS Word',
				'level' : 2
			},
		],
		'education' : [
			{
				'accreditation' : 'MA in Business & Marketing Management',
				'institution' : 'University College',
				'location' : 'Dublin, Ireland',
				'dateStart' : '2012',
				'dateEnd' : '2013',
				'description' : 'First Class Honours. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium'
			},
			{
				'accreditation' : 'BA in Business & Marketing Management',
				'institution' : 'UCC',
				'location' : 'Ireland',
				'dateStart' : '2011',
				'dateEnd' : '2012',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'training' : [
			{
				'accreditation' : 'Certication in Excel',
				'institution' : 'Microsoft Inc.',
				'dateStart' : '2012',
				'dateEnd' : '2013',
			},
			{
				'accreditation' : 'Certification in Marketo',
				'institution' : 'Marketo Inc.',
				'dateStart' : '2011',
				'dateEnd' : '2012',
			}
		],
		'languages' : [
			{
				'language' : 'English',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'German',
				'fluency' : 'Fluent',
				'skill' : 5
			},
			{
				'language' : 'Irish',
				'fluency' : 'Intermediate',
				'skill' : 3
			},
			{
				'language' : 'French',
				'fluency' : 'Beginner',
				'skill' : 1
			}
		],
		'hobbies' : [
			{
				'hobby' : 'Running',
			},
			{
				'hobby' : 'Travelling',
			},
			{
				'hobby' : 'Yoga',
			},
			{
				'hobby' : 'Football Coaching',
			},
			{
				'hobby' : 'Cycling',
			},
			{
				'hobby' : 'Mountain Climbing',
			},
			{
				'hobby' : 'Pilates',
			},
			{
				'hobby' : 'Photography',
			},
			{
				'hobby' : 'Rowing',
			},
			{
		'id' : 'C12310',
		'fullname' : 'Chelsea Tyler',
		'initials' : 'CT',
		'notice' : '2 Weeks Notice Period',
		'jobType' : 'Permanent',
		'currentPosition' : 'Senior Marketing Manager',
		'currentPositionCompany' : 'Intel',
		'skillsHighlight' : [
			{
				'text' : 'MS Excel',
				'tab' : 'skills'
			},
			{
				'text' : 'Marketo',
				'tab' : 'skills'
			},
			{
				'text' : 'Photoshop',
				'tab' : 'skills'
			},
			{
				'text' : 'Team Work',
				'tab' : 'experience'
			}
		],
		'experienceHighlight' : '5 Years Professional Experience | 6 Positions',
		'location' : 'Raheen, Limerick',
		'recruiterComments' : [
			'Very motivated to provide great customer service.',
			'Previous 2 years experience with telephone customer service.',
			'Lots of responsibilities including team management.',
			'Has training and certificates in ECDL.',
			'They have fluent English and excellent communication skills.'
		],
		'highLightText' : 'I am a passionate Marketing Manager for 10 years. I love to work with various teams and my clients include start-ups to multinationals. I enjoy problem solving and have ambition to manage marketing teams with small and large budgets.',
		'experience' : [
			{
				'dateStart' : '2015',
				'dateEnd' : '2018',
				'title' : 'Senior Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2014',
				'dateEnd' : '2015',
				'title' : 'Marketing Manager',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			},
			{
				'dateStart' : '2013',
				'dateEnd' : '2014',
				'title' : 'Marketing Team Lead',
				'company' : 'Intel',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'skills' : [
			{
				'skill' : 'MS Excel',
				'level' : 1
			},
			{
				'skill' : 'MS Word',
				'level' : 2
			},
		],
		'education' : [
			{
				'accreditation' : 'MA in Business & Marketing Management',
				'institution' : 'University College',
				'location' : 'Dublin, Ireland',
				'dateStart' : '2012',
				'dateEnd' : '2013',
				'description' : 'First Class Honours. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium'
			},
			{
				'accreditation' : 'BA in Business & Marketing Management',
				'institution' : 'UCC',
				'location' : 'Ireland',
				'dateStart' : '2011',
				'dateEnd' : '2012',
				'description' : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. '
			}
		],
		'training' : [
			{
				'accreditation' : 'Certication in Excel',
				'institution' : 'Microsoft Inc.',
				'dateStart' : '2012',
				'dateEnd' : '2013',
			},
			{
				'accreditation' : 'Certification in Marketo',
				'institution' : 'Marketo Inc.',
				'dateStart' : '2011',
				'dateEnd' : '2012',
			}
		],
		'languages' : [
			{
				'language' : 'English - Fluent',
				'skill' : 3
			},
			{
				'language' : 'German - Fluent',
				'skill' : 3
			},
			{
				'language' : 'Irish - Intermediate',
				'skill' : 2
			},
			{
				'language' : 'French - Beginner',
				'skill' : 1
			}
		],
		'hobbies' : [
			{
				'hobby' : 'Running',
			},
			{
				'hobby' : 'Travelling',
			},
			{
				'hobby' : 'Yoga',
			},
			{
				'hobby' : 'Football Coaching',
			},
			{
				'hobby' : 'Cycling',
			},
			{
				'hobby' : 'Mountain Climbing',
			},
			{
				'hobby' : 'Pilates',
			},
			{
				'hobby' : 'Photography',
			},
			{
				'hobby' : 'Rowing',
			}
		]
	},
]
}
]



// WEBPACK FOOTER //
// ./src/data/candidates.js